import { render, staticRenderFns } from "./EventsSingleHeader.vue?vue&type=template&id=1f49a0ae&"
import script from "./EventsSingleHeader.vue?vue&type=script&lang=js&"
export * from "./EventsSingleHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports